<script>
import forminput from "../../FormComponet/forminput.vue";
import formdate from "../../FormComponet/formdatelimit.vue";
import formcombobox from "../../FormComponet/formcombobox.vue";
import formcheckbox from "../../FormComponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfDonem from "@/models/StrPerfDonem";
export default {
  mixins: [Api, Sabit, StrPerfDonem],
  props: [
    "Id",
    "AddEdit",
    "min_tarih",
    "max_tarih",
    "min_yilbas",
    "max_yilbit",
    "UstKontrol",
    "kontrol",
    "TipId",
  ],
  data() {
    return {
      FormData: {},
      veritipleri: [
        { Id: "1", Value: "Başlangıç" },
        { Id: "2", Value: "Hedef" },
        { Id: "3", Value: "Gerçekleşme" },
      ],
    };
  },
  components: {
    Loader,
    forminput,
    formcheckbox,
    formdate,
    formcombobox,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get(this.Id);
    },
    kontrol() {
      this.Get(this.Id);
    },
    TipId() {
      this.tip_filtrele();
    },
  },
  methods: {
    Get(data) {
      if (data) {
        let Page = {
          PageNumber: "1",
          PageSize: "9999",
        };

        let yilstr = this.min_tarih.substr(0, 4);
        let yil = parseInt(yilstr) - 1;
        this.min_tarih = this.min_tarih.replace(yilstr, yil.toString());

        this.FormDataType.VeriTipi.ComboDataArray = [];

        for (var i = 0; i < this.veritipleri.length; i++) {
          this.FormDataType.VeriTipi.ComboDataArray.push({
            Id: this.veritipleri[i].Id,
            Value: this.veritipleri[i].Value,
          });
        }

        if (data.UstId != null && data.UstId != "") {
          if (this.AddEdit == "Add") {
            let Filter = "&UstId=" + data.UstId + "&Veritipi=1";

            this.ActionsFilterGet({
              Service: "StrPerfDonem",
              Page: Page,
              Filter: Filter,
            }).then((res) => {
              if (res.Data.length > 0) {
                if (this.FormDataType.VeriTipi.ComboDataArray[0].Id == 1) {
                  this.FormDataType.VeriTipi.ComboDataArray.splice(0, 1);
                }
              }
            });
          } else {
            if (data.VeriTipi != 1) {
              let Filter = "&UstId=" + data.UstId + "&Veritipi=1";

              this.ActionsFilterGet({
                Service: "StrPerfDonem",
                Page: Page,
                Filter: Filter,
              }).then((res) => {
                if (res.Data.length > 0) {
                  if (this.FormDataType.VeriTipi.ComboDataArray[0].Id == 1) {
                    this.FormDataType.VeriTipi.ComboDataArray.splice(0, 1);
                  }
                }
              });
            }
          }
        }
      }
    },

    tip_filtrele() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };

      let Filter = "&Tip=1561";
      this.FormDataType.TipId.ComboDataArray = [];
      if (this.UstKontrol == 0 && this.TipId != null) {
        this.ActionsFilterGet({
          Service: "OKeyValues",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
            if (res.Data[i].Id == this.TipId) {
              this.FormDataType.TipId.ComboDataArray.push({
                Id: res.Data[i].Id,
                Value: res.Data[i].Value,
              });
            }
          }
        });
      } else {
        this.ActionsFilterGet({
          Service: "OKeyValues",
          Page: Page,
          Filter: Filter,
        }).then((res) => {
          for (var i = 0; i < res.Data.length; i++) {
            this.FormDataType.TipId.ComboDataArray.push({
              Id: res.Data[i].Id,
              Value: res.Data[i].Value,
            });
          }
        });
      }
    },

    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.FormData.OlcumPeriyodu == "") {
          this.FormData.OlcumPeriyodu = null;
        }

        if (
          this.FormData.Approval == "true" ||
          this.FormData.Approval == true
        ) {
          this.FormData.Approval = true;
        } else {
          this.FormData.Approval = false;
        }

        if (this.FormData.Hedefmi == "true" || this.FormData.Hedefmi == true) {
          this.FormData.Hedefmi = true;
        } else {
          this.FormData.Hedefmi = false;
        }

        if (!this.FormData.UstId || this.FormData.UstId == "0") {
          this.$delete(this.FormData, "UstId");
        }

        if (this.AddEdit == "Add") {
          this.$delete(this.FormData, "Id");

          this.Post("StrPerfDonem", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");

              this.$bvModal.hide("StrPerfDonem");
            }
          });
        } else {
          this.Update("StrPerfDonem", this.FormData).then((res) => {
            if (res) {
              //this.$emit("Update", this.FormData);
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrPerfDonem");
            }
          });
        }
      }
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrPerfDonem"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrPerfDonem.AddEdit.FormTitleEdit')
          : $t('StrPerfDonem.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">

 
        <div class="row">
          <div v-if="UstKontrol == '0'" class="col-md-8">
            <formcombobox
              :title_position="'d-block'"
              :labels_lg="8"
              :FormDataType="FormDataType.UstId"
              :Value="FormData.UstId"
              :v="$v.FormData.UstId"
              @input="FormData.UstId = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <forminput
              :title_position="'d-block'"
              :labels_lg="6"
              :min="min_yilbas"
              :max="max_yilbit"
              :FormDataType="FormDataType.YilBas"
              :Value="FormData.YilBas"
              :v="$v.FormData.YilBas"
              @input="FormData.YilBas = $event"
            />
          </div>

          <div class="col-md-6">
            <forminput
              :title_position="'d-block'"
              :labels_lg="6"
              :min="min_yilbas"
              :max="max_yilbit"
              :FormDataType="FormDataType.YilBit"
              :Value="FormData.YilBit"
              :v="$v.FormData.YilBit"
              @input="FormData.YilBit = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <forminput
              :title_position="'d-block'"
              :labels_lg="6"
              :FormDataType="FormDataType.Aciklama"
              :Value="FormData.Aciklama"
              :v="$v.FormData.Aciklama"
              @input="FormData.Aciklama = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <formdate
              :title_position="'d-block'"
              :labels_lg="6"
              :min="min_tarih | formatDate"
              :max="max_tarih | formatDate"
              :FormDataType="FormDataType.BaslamaTarihi"
              :Value="this.$options.filters.formatDate(FormData.BaslamaTarihi)"
              :v="$v.FormData.BaslamaTarihi"
              @input="FormData.BaslamaTarihi = $event"
            />
          </div>

          <div class="col-md-6">
            <formdate
              :title_position="'d-block'"
              :labels_lg="6"
              :min="min_tarih | formatDate"
              :max="max_tarih | formatDate"
              :FormDataType="FormDataType.BitisTarihi"
              :Value="this.$options.filters.formatDate(FormData.BitisTarihi)"
              :v="$v.FormData.BitisTarihi"
              @input="FormData.BitisTarihi = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <formcombobox
              :title_position="'d-block'"
              :labels_lg="6"
              :FormDataType="FormDataType.TipId"
              :Value="FormData.TipId"
              :v="$v.FormData.TipId"
              @input="FormData.TipId = $event"
            />
          </div>

          <div class="col-md-6">
            <formcombobox
              :title_position="'d-block'"
              :labels_lg="6"
              :FormDataType="FormDataType.VeriTipi"
              :Value="FormData.VeriTipi"
              :v="$v.FormData.VeriTipi"
              @input="FormData.VeriTipi = $event"
            />
          </div>
        </div>
        <div class="row">
          <!--    <div class="col-md-6" v-if="UstKontrol == '0'">
                      <formcombobox
                        :title_position="'d-block'"
                        :labels_lg="8"
                        :FormDataType="FormDataType.OlcumPeriyodu"
                        :Value="FormData.OlcumPeriyodu"
                        :v="$v.FormData.OlcumPeriyodu"
                        @input="FormData.OlcumPeriyodu = $event"
                      />
                  </div>  -->
          <div class="col-md-6">
            <forminput
              :title_position="'d-block'"
              :labels_lg="6"
              :min="'0'"
              :max="'999999999'"
              :FormDataType="FormDataType.Sira"
              :Value="FormData.Sira"
              :v="$v.FormData.Sira"
              @input="FormData.Sira = $event"
            />
          </div>
          <div class="col-md-6">
            <br /><br />

            <formcheckbox
              :title_position="'mb-3'"
              :labels_lg="4"
              :FormDataType="FormDataType.Approval"
              :Value="FormData.Approval"
              :v="$v.FormData.Approval"
              @input="FormData.Approval = $event"
            />
          </div>
          <div class="col-md-6" v-if="FormData.VeriTipi == 3">
            <br /><br />

            <formcheckbox
              :title_position="'mb-3'"
              :labels_lg="4"
              :FormDataType="FormDataType.Ilkaltiay"
              :Value="FormData.Ilkaltiay"
              :v="$v.FormData.Ilkaltiay"
              @input="FormData.Ilkaltiay = $event"
            />
          </div>
        </div>

        <hr />

        <button class="btn btn-primary" type="submit">
          {{ $t("StrPerfDonem.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
